// extracted by mini-css-extract-plugin
export var card = "portfolio-module--card--FdvJ0";
export var cardImage = "portfolio-module--card-image--Zh2Ht";
export var grid = "portfolio-module--grid--dbs+c";
export var gridItem = "portfolio-module--grid-item--AUJYM";
export var link = "portfolio-module--link--yU4ui";